/**
 * Case-insensitive EVM address matching. API layers return a mix of
 * checksummed and lowercase addresses (see backend 3eaf413) — never
 * compare addresses with `===`.
 */
export const sameAddress = (a?: string, b?: string): boolean => !!a && !!b && a.toLowerCase() === b.toLowerCase();

export const findByAddress = <T extends { address?: string }>(list: readonly T[], address?: string): T | undefined =>
  list.find(item => sameAddress(item.address, address));
